import Dialog from "@components/dialog";
import BindingContext from "@odata/BindingContext";
import { AttendanceFormPage } from "@pages/payroll/payslip/overview/AttendanceFormPage";
import OverviewBase, { IOverviewBaseProps } from "@pages/payroll/payslip/overview/OverviewBase";
import {
    getAttendanceOverviewSections,
    isAnyAttendanceOpen,
    isAttendanceClosed
} from "@pages/payroll/payslip/Payslip.utils";
import { IPrPayslipFormStorageCustomData } from "@pages/payroll/payslip/PayslipFormView";
import { memoizeOne } from "@utils/memoizeOne";
import i18next from "i18next";
import React from "react";

import { getEntityMemoKey } from "../../../../views/formView/Form.utils";

interface IProps extends IOverviewBaseProps {
    employmentBindingContext: BindingContext;
    onAttendanceChange?: () => void;
}

export default class AttendanceOverview extends OverviewBase<IProps> {
    _title = i18next.t("Payslip:Form.Attendance");
    _hasChangeAttendance = false;

    get placeholder(): string {
        const { storage, employmentBindingContext } = this.props;
        const isClosed = isAttendanceClosed(storage, employmentBindingContext);
        return i18next.t(`Payslip:Form.${isClosed ? "ClosedAttendance" : "NotClosedAttendance"}`);
    }

    get showPlaceholder(): boolean {
        return isAnyAttendanceOpen(this.props.storage);
    }

    getSections = memoizeOne(() => {
        return getAttendanceOverviewSections(this.props.storage, this.props.employmentBindingContext);
    }, () => {
        const customData = this.props.storage.getCustomData() as IPrPayslipFormStorageCustomData;
        return [
            [getEntityMemoKey(this.props.storage)],
            this.props.employmentBindingContext.getFullPath(),
            customData.CurrentPeriodHolidays,
            customData.CurrentPeriodWorkDays
        ];
    });

    handleAttendanceChange = (): void => {
        this._hasChangeAttendance = true;
    }

    handleCloseDialog = (): void => {
        this.setState({ isEditDialogOpen: false });
        if (this._hasChangeAttendance) {
            this.getSections.reset();
            this.props.onAttendanceChange?.();
            this._hasChangeAttendance = false;
        }
    };

    renderEditDialog(): React.ReactElement {
        return (
                <Dialog onClose={this.handleCloseDialog}
                        onConfirm={this.handleSave}
                        isEditableWindow>
                    <AttendanceFormPage rootStorage={this.props.storage}
                                        employmentBindingContext={this.props.employmentBindingContext}
                                        onAttendanceChange={this.handleAttendanceChange}
                                        onClose={this.handleCloseDialog} />
                </Dialog>
        );
    }
}
